var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aprh__authentication__login"},[_c(_vm.input,{tag:"component",staticClass:"aprh__authentication__form__field",attrs:{"settings":{
            label: { class: 'field__label__login capitalize', text: _vm.$t('global.email') },
            input: {
                component: 'InputBasic',
                id: 'email',
                name: 'email',
                type: 'text',
                class: 'aprh__authentication__form__field__input',
                value: '',
                placeholder: _vm.$t('global.email'),
                browserAutocomplete: 'email',
                isRequired: true,
                fileValidation: 'basicEmail',
                errors: [{
                    type: 'email', warning: _vm.$t('error.email')
                }],
                isMissing: _vm.errors.missing.email,
                noListener: true
            },
            allowFilling: true
        }}}),_c('base-password',{staticClass:"aprh__authentication__form__field",attrs:{"input":_vm.input,"settings":{
            label: { class: 'capitalize field__label__login', text: _vm.$t('global.password') },
            input: {
                name: 'password',
                class: 'aprh__authentication__form__field__input',
                placeholder: _vm.$t('global.password'),
                fileValidation: null,
                browserAutocomplete: 'current-password',
                isMissing: _vm.errors.missing.password,
                noListener: true
            }
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }